import axios, {AxiosResponse} from 'axios';

export function getCurrentlyLoggedInUser(): Promise<string> {
    return axios.get('oauth/current_user').then((resp: AxiosResponse<string>) => resp.data);
}



// WEBPACK FOOTER //
// ./src/apis/UserAPI.ts